$(function () {
  if (!customElements.get('about-application-scenarios')) {
    customElements.define(
      'about-application-scenarios',
      class aboutApplicationScenarios extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.init();
        }

        init() {
          const root = $(this); // 保存当前实例对应的 DOM 元素
          const $tabs = root.find('.tab');
          const $mySwiper = root.find('.mySwiper')[0];
          const $slide = root.find('.swiper-slide');

          let swiper;
          if ($slide.length > 1) {
            swiper = new Swiper($mySwiper, {
              spaceBetween: 20,
              on: {
                slideChange: (swiper) => {
                  root.find('.tab.active').removeClass('active');
                  $($tabs[swiper.realIndex]).addClass('active');
                },
              },
            });
          }

          $tabs.each((index, tab) => {
            $(tab).on('click', (event) => {
              root.find('.tab.active').removeClass('active');
              $(tab).addClass('active');
              if (swiper) {
                swiper.slideTo(index);
              }
            });
          });

          // 初始化第一个 tab
          $tabs.eq(0).trigger('click');
        }
      }
    );
  }
});
